
import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultBg from "../../assets/inclusionBg.jpg";
import checkIcon from "../../assets/checkIcon.png";
import callIconIcon from "../../assets/calendar.png";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(46,33,33,0.65)",
  },
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
    textTransform: "uppercase",
  },

  titleDate: {
    fontFamily: "Montserrat",
    fontSize: 24,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 20,
    textTransform: "uppercase",
  },

  listItem: {
    flexDirection: "row",
    alignItems: "center", 
    marginTop: 14,
    paddingHorizontal: 20,
    gap: 25
  },
  bulletIcon: {
    width: 12,
    height: 12,
    marginRight: 10,
    marginTop: 4,
  },
  listText: {
    fontSize: 16,
    color: "#fff",
    fontFamily: "Montserrat",
    lineHeight: 1.4,
    flex: 1,
    fontWeight: "medium",
    textShadow: "0px 0px 10px #000",
  },
  bullet: {
    fontSize: 18,
    color: "#fff",
    marginRight: 10,
    marginTop: -2,
    textShadow: "1px 1px 2px #000",
  },
  dayNumberClass: {
    width: 60,
    height: 60,
    backgroundColor: "#fff",
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
  },
  dayNumber: {
    color: "#FF0000",
    fontSize: 40,
    fontFamily: "Montserrat",
    fontWeight: "semibold",
  },
  headingSection: {
    flexDirection: "row",
    alignItems: "center",
    gap: 15,
    justifyContent: "center",
  },
  icon: {
    width: 50,
    height: 46,
    margin: "10 auto 4",
  },
  checkIcon: {
    width: 28,
    height: 28,
    objectFit: "contain",
  },
});

const ItinerarySlide = ({
  bg,
  title = "INCLUSIONS",
  dayNumber,
  date,
  points = [],
  icon,
}) => {
   const iconImage = icon || callIconIcon;
   const backgroundImage = bg || defaultBg;
  return (
    <Page size={PDF_PAGE} style={styles.page}>
      <Image src={backgroundImage} style={styles.background} />
      <View style={styles.overlay} />

      <View style={styles.container}> 
        <Image src={iconImage} style={styles.icon} />
        <View style={styles.headingSection}>
          <View style={styles.dayNumberClass}>
            <Text style={styles.dayNumber}>{dayNumber}</Text>
          </View>
          <Text style={styles.title}>{title}</Text>
        </View>

        <Text style={styles.titleDate}>{date}</Text>

        {points.map((item, idx) => (
          <View style={styles.listItem} key={idx}>
            <Image src={checkIcon} style={styles.checkIcon} />
            <Text style={styles.listText}>{item}</Text>
          </View>
        ))}
      </View>
    </Page>
  );
};

export default ItinerarySlide;
